import { OrbitControls } from "three/addons/controls/OrbitControls.js";
import { Spherical, type Camera } from "three";

const IDLE_SEC = 8;
const AUTO_ORBIT_RAD_PER_S = 0.06;

export interface SandboxControls {
  enable: () => void;
  disable: () => void;
  update: (t: number, dt: number) => void;
  raw: OrbitControls;
}

export function createSandboxControls(camera: Camera, dom: HTMLElement): SandboxControls {
  const controls = new OrbitControls(camera, dom);
  controls.enableDamping = true;
  controls.dampingFactor = 0.08;
  controls.minDistance = 5;
  controls.maxDistance = 60;
  controls.enabled = false;

  let lastInput = performance.now() / 1000;
  const markInput = () => { lastInput = performance.now() / 1000; };
  ["pointerdown", "wheel", "keydown"].forEach((e) =>
    dom.addEventListener(e, markInput, { passive: true }),
  );

  const sph = new Spherical();
  function update(t: number, dt: number) {
    if (!controls.enabled) return;
    if (t - lastInput > IDLE_SEC) {
      const offset = camera.position.clone().sub(controls.target);
      sph.setFromVector3(offset);
      sph.theta += AUTO_ORBIT_RAD_PER_S * dt;
      offset.setFromSpherical(sph);
      camera.position.copy(controls.target).add(offset);
    }
    controls.update();
  }

  return {
    enable: () => { controls.enabled = true; markInput(); },
    disable: () => { controls.enabled = false; },
    update,
    raw: controls,
  };
}
